// pages links
export const navLinks = [
  { title: "Write a Joke", link: "/" },
  { title: "Punch Up a Joke", link: "/punch-joke" },
  { title: "Witrater", link: "/witrater" },
  { title: "Get Setups", link: "/get-setups" },
];
